import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { v4 as UUIDGenerator } from 'uuid';
import resolvePath from '../../../misc/resolvePath';
import CollectClick from '../../collect/CollectClick';
import CollectContextProvider from '../../collect/CollectContextProvider';
import CommunityEvents from '../../elements/CommunityEvents';
import Link from '../../elements/Link';
import Scrollable from '../../elements/Scrollable';
import SectionLinkedHeader from '../../elements/SectionHeader/SectionLinkedHeader/SectionLinkedHeader';
import EventSocialMenu from '../../elements/SocialMenu/EventSocialMenu';
import SponsorsCarousel from '../../elements/SponsorsCarousel/SponsorsCarousel';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import LoadMeetings from '../../loaders/LoadMeetings';
import LoadNews from '../../loaders/LoadNews';
import LoadProgram from '../../loaders/LoadProgram';
import LoadQAQuestions from '../../loaders/LoadQAQuestions';
import LoadSpeakers from '../../loaders/LoadSpeakers';
import WaitWhileBusy from '../../WaitWhileBusy';
import EventInfoContent from '../EventInfo/EventInfoContent';
import EventParticipantDisambiguation from './../EventParticipantDisambiguation';
import Screen from './../Screen';
import EventQuests from './common/CommonEventQuests/CommonEventQuests';
import { CustomEnrichment } from './common/enrichmentButtons/CustomEnrichment';
import { ProfileEnrichment } from './common/enrichmentButtons/ProfileEnrichment';
import EventFormsButton from './common/EventFormsButton/EventFormsButton';
import EventHeaderImage from './common/EventHeaderImage/EventHeaderImage';
import EventExhibitorsButton from './common/EventExhibitorsButton/EventExhibitorsButton';
import EventHomeScreenButton from './common/EventHomeScreenButton/EventHomeScreenButton';
import EventIcons from './common/EventIcons/EventIcons';
import EventProgramSection from './common/EventProgramSection/EventProgramSection';
import HomeEventParticipants from './common/HomeEventParticipants/HomeEventParticipants';
import LeadScan from './common/LeadScan';
import { PollOptions } from './common/PollOptions/PollOptions';
import RecentNews from './common/RecentNews/RecentNews';

export class EventHomeScreen extends React.Component {
    render() {
        var { i18n, event, eventId } = this.props;

        if (!event.joined && this.props.event && this.props.parent) {
            return <Redirect to={['/events', this.props.parent.id, 'agenda', 'subevent', event.id].join('/')} />;
        } else if (this.props.participantsDisambiguation) {
            return <EventParticipantDisambiguation eventId={this.props.eventId} matches={this.props.participantsDisambiguation} i18n={this.props.i18n} />;
        }

        var speakers;
        if (this.props.hasSpeakers && event.settings.show_speakers_list >= 2) {
            speakers = (
                <div className="content striped">
                    <SectionLinkedHeader href="./speakers" color={event.settings.primary_color} next>
                        {i18n['label.speakers']}
                    </SectionLinkedHeader>
                </div>
            );
        }

        let sponsors;
        if (event.sponsors) {
            sponsors = <SponsorsCarousel eventId={event.id} sponsors={event.sponsors} />;
        }

        let buttons;
        if (event.buttons) {
            buttons = (
                <>
                    {_(event.buttons)
                        .filter({ is_home_button: true })
                        .map((button, i) => {
                            return (
                                <CollectClick objectType="sponsor.banner" objectId={button.id} key={`button-${i}`}>
                                    <EventHomeScreenButton event={event} button={button} />
                                </CollectClick>
                            );
                        })
                        .value()}
                </>
            );
        }

        let header = (
            <div>
                <TopBarEvent event={event} showLogo="showLogo" returnURL="/" />
            </div>
        );

        let footer = <div className="" />;

        let formsButton;
        if (event.forms && event.forms.length) {
            formsButton = <EventFormsButton eventId={this.props.eventId} />;
        }

        return (
            <CollectContextProvider context="screen-home">
                <Screen header={header} footer={footer}>
                    <Scrollable>
                        <Link href={['/events', event.id, 'info'].join('/')}>
                            <EventHeaderImage event={event} />
                        </Link>
                        <EventIcons i18n={i18n} event={event} news={this.props.news} />
                        <LeadScan event={event} />
                        {event.show_info_on_home ? (
                            <div className="striped">
                                <div className="content">
                                    <SectionLinkedHeader color={event.settings.primary_color} next href="./info">
                                        {i18n['label.event.info']}
                                    </SectionLinkedHeader>
                                </div>
                                <EventInfoContent event={event} />
                            </div>
                        ) : null}
                        <HomeEventParticipants eventId={eventId} />
                        <EventQuests i18n={i18n} event={event} />
                        <EventProgramSection event={event} />
                        {speakers}
                        <CommunityEvents event={this.props.event} i18n={i18n} />
                        <RecentNews event={this.props.event} />
                        <ProfileEnrichment event={this.props.event} i18n={i18n} />
                        <CustomEnrichment event={this.props.event} i18n={i18n} />
                        <PollOptions event={this.props.event} i18n={i18n} />
                        {buttons}
                        <EventExhibitorsButton event={event} />
                        <div className="marginTop marginBottom">{sponsors}</div>
                        <EventSocialMenu event={event} />
                    </Scrollable>
                </Screen>
                {formsButton}
            </CollectContextProvider>
        );
    }
    handleCreateForm(eventForm) {
        let state = app.store.getState(),
            hasAnswers =
                _(state.forms.drafts)
                    .filter((answer) => answer.formId == eventForm.id && answer.eventId == this.props.eventId)
                    .value().length ||
                _(state.forms.uploading)
                    .filter((answer) => answer.formId == eventForm.id && answer.eventId == this.props.eventId)
                    .value().length;

        if (hasAnswers) {
            app.history.push(resolvePath(app.history.location.pathname, 'forms', eventForm.id.toString()));
        } else {
            let uid = UUIDGenerator();
            app.store.dispatch(app.actions.forms.createResponse(this.props.eventId.toString(), eventForm.id.toString(), uid));
            app.history.push(resolvePath(app.history.location.pathname, 'forms', eventForm.id.toString(), uid));
        }
    }
}

export const StateConnectedEventHomeScreen = connect(function (state, props) {
    var now = new Date().valueOf();

    const parentId = state.events.parents[props.eventId],
        parent = state.events[parentId]?.event;

    return {
        eventId: props.eventId,
        event: state.events[props.eventId].event,
        i18n: state.i18n.translations,
        participantsDisambiguation: state.events[props.eventId].participants.disambiguation,
        news: state.events[props.eventId].news.listed,
        hasSpeakers: !!state.events[props.eventId].speakers.listed.length,
        parent,
    };
})(EventHomeScreen);

export default (props) => (
    <LoadQAQuestions eventId={props.match.params.eventId} skipSpinner>
        <LoadProgram eventId={props.match.params.eventId}>
            <LoadSpeakers eventId={props.match.params.eventId}>
                <LoadMeetings eventId={props.match.params.eventId}>
                    <LoadNews eventId={props.match.params.eventId}>
                        <WaitWhileBusy>
                            <StateConnectedEventHomeScreen {...props.match.params} />
                        </WaitWhileBusy>
                    </LoadNews>
                </LoadMeetings>
            </LoadSpeakers>
        </LoadProgram>
    </LoadQAQuestions>
);
